import React, { useState } from 'react';
import useWebSocket from 'react-use-websocket';
import { baseUrl } from '../services/httpSvc';

const webSocketUrl = baseUrl.replace('https://', 'wss://').replace('http://', 'ws://');

export const JobProgressStatus = (props) => {
  const accessToken = localStorage.getItem('accessToken');
  const [socketUrl] = useState(`${webSocketUrl}jobs/${props.jobId}/ws?token=${accessToken}`);
  const { lastMessage } = useWebSocket(socketUrl);

  return (
    <div>
      {lastMessage ? <span style={{ color: 'white' }}>{JSON.stringify(lastMessage.data, null, 2)}</span> : null}
    </div>
  );
};
